__turbopack_context__.v({
  "content": "AccordionContent-module__YM6LnW__content",
  "contentOpen": "AccordionContent-module__YM6LnW__contentOpen",
});
